import React, { useContext, useState } from "react";
import "./ECLObjectBlock.css";
import { ECLCheckBox } from "../../../index";
import { ToastContext } from "../../../../utilities/contexts";
import { translate } from "../../../../utilities/Translate";

export default function ECLObjectBlock() {
   const [hardcodedCheckboxChecked, setHardcodedCheckboxChecked] =
      useState(false);
   const addToast = useContext(ToastContext);

   return (
      <div className="object-block">
         <form
            onSubmit={(e) => {
               e.preventDefault();
               addToast("You clicked submit!");
            }}
         >
            <div className="form-field">
               <label htmlFor="Notes">Notes</label>
               <div className="input-div">
                  <textarea />
               </div>
            </div>
            <div className="form-field">
               <label htmlFor="Resolved?">Resolved?</label>
               <div className="input-div">
                  <ECLCheckBox
                     checked={hardcodedCheckboxChecked}
                     handleClick={() =>
                        setHardcodedCheckboxChecked(!hardcodedCheckboxChecked)
                     }
                  />
               </div>
            </div>
            <div className="button-div">
               <button type="submit">{translate("Submit")}</button>
            </div>
         </form>
      </div>
   );
}
